"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    InputSelect: ()=>InputSelect
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_InputSelect_variants_cjs_namespaceObject = require("./InputSelect.variants.cjs");
const index_cjs_namespaceObject = require("../Select/index.cjs");
const external_react_namespaceObject = require("react");
function InputSelect({ labelText, options, name, defaultValue = options[0]?.value ?? '', onChange, size, isAutoWidth = false, selectMinWidth, selectPadding, ...restProps }) {
    const { root, labelSlot } = (0, external_InputSelect_variants_cjs_namespaceObject.inputSelectVariants)({
        size
    });
    const [currentValue, setCurrentValue] = (0, external_react_namespaceObject.useState)(defaultValue);
    const selectedOption = options.find((option)=>option.value === currentValue) || options[0] || {
        value: '',
        label: ''
    };
    const menuItems = options.map((option)=>({
            label: String(option.label),
            value: String(option.value)
        }));
    const handleChange = (value)=>{
        const numericValue = isNaN(Number(value)) ? value : Number(value);
        setCurrentValue(numericValue);
        const selectEvent = {
            target: {
                value: numericValue,
                name
            }
        };
        onChange(selectEvent);
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: root(),
        "data-testid": "input-select-component",
        children: [
            labelText ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("label", {
                htmlFor: name,
                className: labelSlot(),
                children: labelText
            }) : null,
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Select, {
                selectPadding: selectPadding,
                selectMinWidth: selectMinWidth,
                label: labelText || '',
                isLabelHidden: true,
                menuItems: menuItems,
                placeholder: String(selectedOption?.label || ''),
                initialValue: String(currentValue),
                onChange: handleChange,
                size: size,
                isAutoWidth: isAutoWidth,
                ...restProps
            })
        ]
    });
}
exports.InputSelect = __webpack_exports__.InputSelect;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "InputSelect"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
